module.exports = __webpack_public_path__ + "img/table-circle-plus.06f5ed76.svg";